<template lang="pug">
.company_selector
  label Search existing companies
  v-select(@search='fetchCompanies' :options='companies' v-model='company' :filterable='false' @input='selected')
</template>
<script lang="ts">
import throttle from 'lodash/throttle'
import admin_api from '@app/mixins/admin_api'

export default {
  mixins: [admin_api],
  data() {
    return {
      company: null,
      companies: [],
    }
  },
  methods: {
    fetchCompanies(term) {
      this.search(term, this)
    },

    search: throttle((term, comp) => {
      comp.searchCompanies(term).then((result) => {
        comp.companies = result.data.companies
      })
    }, 500),
    selected() {
      this.$emit('input', this.company.code)
    },
  },
}
</script>
<style lang="sass" scoped></style>
